const state = {
    userDetails: {}
};
const actions = {};
const getters = {};
const mutations = {
    setUserDetails(state, payload) {
        state.userDetails = payload.userDetails;
    }

};
export default {
    state,
    actions,
    getters,
    mutations
};
